import { ACTION, RequestChangeCaseStatus, ReceiveChangeCaseStatus, RequestCallsToActions, ReceiveCallsToActions } from './action-types';
import { CaseState } from 'app/area/case/types-store';
import { ActionMap } from 'app/area/case';

export const reducers: ActionMap = {

  [ACTION.REQUEST_CALLS_TO_ACTIONS]: (state: CaseState, action: RequestCallsToActions): CaseState => {
    return {
      ...state,
      ...{
        fetching: true
      }     
    };
  },
  
  [ACTION.RECEIVE_CALLS_TO_ACTIONS]: (state: CaseState, action: ReceiveCallsToActions): CaseState => {
    return {
      ...state,      
      ...{
        fetching: false,
        changingCaseStatus: false,
        callsToActions: action.callsToActions
      }
    };
  },

  [ACTION.REQUEST_CHANGE_STATUS]: (state: CaseState, action: RequestChangeCaseStatus): CaseState => {
    return {
      ...state,
      ...{
        changingCaseStatus: true
      }     
    };
  },
  
  [ACTION.RECEIVE_CHANGE_STATUS]: (state: CaseState, action: ReceiveChangeCaseStatus): CaseState => {
    return {
      ...state,      
      ...{
        changingCaseStatus: false,
        status: action.status
      }
    };
  },

  [ACTION.REQUEST_CONNECT_EXISTING]: (state: CaseState, action: ReceiveChangeCaseStatus): CaseState => {
    return {
      ...state,      
      ...{
        changingDraftConnection: true
      }
    };
  },

  [ACTION.RECEIVE_CONNECT_EXISTING]: (state: CaseState, action: ReceiveChangeCaseStatus): CaseState => {
    return {
      ...state,      
      ...{
        changingDraftConnection: false
      }
    };
  }
};
